import PropTypes from 'prop-types'
import React, { cloneElement } from 'react'

const TabGroup = ({ className, children, selectedIndex }) => {
  const panels = children.filter(panel => panel !== null).map((panel, i) =>
    cloneElement(panel, {
      key: i,
      isSelected: selectedIndex === i
    })
  )

  return <div className={className}>{panels}</div>
}

TabGroup.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  selectedIndex: PropTypes.number
}

TabGroup.defaultProps = {
  className: null,
  children: null,
  selectedIndex: 0
}

export default TabGroup
